import { Injectable } from '@angular/core';
import { BaseEvent } from './definitions/base-event';
import { Subject } from 'rxjs';
import { AllOutgoingEvents } from './definitions';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class OutgoingEventsSenderService {
  private readonly mobileEventsDebugEnabled = environment.mobileEventsDebugEnabled;

  private eventsSink$ = new Subject<BaseEvent>();

  public register(): void {
    this.eventsSink$.subscribe((event) => this.onEventReceived(event));
  }

  public send(event: AllOutgoingEvents): void {
    this.eventsSink$.next(event);
  }

  private onEventReceived(event: BaseEvent): void {
    if (this.mobileEventsDebugEnabled) {
      console.log('[OutgoingEventsSenderService] Send', event);
    }

    // Special hack for mobile app integration

    const sendMethod = (e: BaseEvent): void => {
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (!(window as any).mobileAppEventsSender?.postMessage) {
        return;
      }

      const payload = JSON.stringify(e);

      if (this.mobileEventsDebugEnabled) {
        console.log('[OutgoingEventsSenderService] Send to method', payload);
      }
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).mobileAppEventsSender.postMessage(payload);
    };

    sendMethod(event);
  }
}
